import {useI18n} from '@yandex-delivery/core/i18n'
import {useMemo} from 'react'

import type {PickupPoint} from '../../../../../api/address/model/types'

export const useDetails = (point?: PickupPoint) => {
  const i18n = useI18n()
  const time = useMemo(() => {
    switch (point?._type) {
      case 'terminal':
        return i18n('ndd.pickup_points.terminal.storage_time', '3 дня')
      case 'pickup_point':
        return i18n('ndd.pickup_points.pickup_point.storage_time', '7 дней')
      case 'yandex_market':
        return i18n('ndd.pickup_points.pickup_point.storage_time', '7 дней')
      case 'post_office':
        return i18n('ndd.pickup_points.post_office.storage_time', '7 дней')
      case 'sorting_center':
        return i18n('ndd.pickup_points.sorting_center.storage_time', '7 дней')
      default:
        return ''
    }
  }, [point?._type, i18n])

  const schedule = useMemo(() => {
    if (point?.schedule === undefined) {
      return []
    }

    return point.schedule
  }, [point?.schedule])

  return {
    time,
    schedule,
  }
}
